import { twMerge } from 'tailwind-merge';
import { useState } from 'react';
import SettingsModal from '@/features/user-profile/profile-settings/components/SettingsModal';
import { ReactComponent as SettingsIcon } from '@/assets/icons/settings-icon.svg';

const ProfileConfiguration = ({ onSettingsOpen }: { onSettingsOpen?: () => void }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);

    if (onSettingsOpen) {
      onSettingsOpen();
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <SettingsIcon
        className={twMerge(
          'h-5 w-5 cursor-pointer',
          isOpen ? 'text-ph-primary-violet hover:text-ph-primary-violet' : 'text-ph-white-50 hover:text-ph-white',
        )}
        onClick={handleOpen}
      />
      {isOpen && <SettingsModal isOpen={isOpen} onClose={() => handleClose()} />}
    </>
  );
};

export default ProfileConfiguration;
